export enum CollectionsGalleryWidgetComponentIds {
  Root = '#collectionsGalleryRoot',
  GalleyWidget = '#collectionsGallery',
}

export enum CollectionsGalleryWidgetEvents {}
